import React, {Component} from 'react';


export default class TrackedEmail extends Component {
  clickedEmail = (location, email) => {
    window.analytics.track("Clicked Email", {location: location, email: email});
    this.props.onClick();
  };

  rightClickedEmail = (location, email) => {
    window.analytics.track("Clicked Email", {location: location, type: "Right Click", email: email});
    this.props.onContextMenu();
  };

  copiedEmail = (location, email) => {
    window.analytics.track("Clicked Email", {location: location, type: "Copy", email: email});
    this.props.onCopy();
  };

  render() {
    const {email, location, target = '_blank', ...otherProps} = this.props;

    return (
      <a {...otherProps}
         onClick={() => this.clickedEmail(location, email)}
         onContextMenu={() => this.rightClickedEmail(location, email)}
         onCopy={() => this.copiedEmail(location, email)}
         target={target}
         href={"mailto:" + email}>{email}</a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/parts/TrackedEmail.js